module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-left-inactive-0d4f3706bc8b82bef9cfd77019ec0fa5.svg";